module.exports = __webpack_public_path__ + "img/admin-logo@2x.11d51ddb.png";